export enum RuleType {
  RULE = 'RULE',
  EXCEPTION = 'EXCEPTION',
}